import {DayMonth, DayPipe, FullDatePipe, HourPipe, ShortDatePipe} from '../depends/pipe/date.pipe';
import {FormBuilder, FormGroup, Validators, FormControl, AbstractControl} from '@angular/forms';
import {Component, Inject, Input, OnInit, ElementRef, ViewChild} from '@angular/core';
import {NgxLoopReportService} from './ngx-loop-report.service';
import {TranslateService} from '../translate.service';
import {formatDate,formatNumber,Location, DatePipe, DecimalPipe} from '@angular/common';
import { MatSnackBarConfig, MatSnackBar, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatDatepicker, MatTableDataSource, MatTable } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import moment, { Moment } from 'moment';
import { ConfigurationService } from '../depends/configuration.service';
import {SecToDateTime} from '../sec-to-date-pipe';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'NgxLoopReport',
  templateUrl: './ngx-loop-report.html',
  styleUrls: ['./ngx-loop-report.css' ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})

export class NgxLoopReportComponent implements OnInit {

  @Input() reportId: number = null;
  @Input() external: boolean = false;
  @Input() externalParams : any = null;
  @ViewChild("iframe", {static: true}) iframe: ElementRef<HTMLIFrameElement>;
  @ViewChild("stylePrint", {static: true}) stylePrint: ElementRef<HTMLStyleElement>;

  dataexport = new MatTableDataSource<any>();
  dataexportfields:string[] = [];
  @ViewChild('exporter',{static:true})exporter:HTMLTableElement;
  @ViewChild('pdfViewer', {static: true}) pdfViewer: ElementRef<HTMLIFrameElement>;

  showOptions:boolean = true;
  printing: boolean = false;
  exporting: boolean = false;
  loading: boolean = false;
  reportType:string = null;
  reportTypes:any[] = [];
  formModel:any = null;
  formGroup:FormGroup;
  date_start:string;
  tables:any[] = [];
  group_tables:any[] = [];
  group_tables_html:string = "";
  date_end:string;
  report:any;
  fields:any = {};

  // Alterando Lib!

  constructor(
    private formBuilder:FormBuilder,
    private reportService:NgxLoopReportService,
    private fullDatePipe: FullDatePipe,
    private shortDatePipe: ShortDatePipe,
    private hourPipe: HourPipe,
    private dayMonth: DayMonth,
    private dayPipe: DayPipe,
    private secToDateTime: SecToDateTime,
    public translate : TranslateService,
    private _location: Location,
    private _snackBar: MatSnackBar,
    private configurationService:ConfigurationService,
    private datePipe: DatePipe,
    private decimalPipe:DecimalPipe
  ) {}

  ngOnInit() {
    if(this.reportId != null){
      this.loading = true;
      this.reportService.getUserReports().then((reports) => {
        this.loading = false;
        let report = reports.find( report => report.ID == this.reportId)
        if(report != null){
          this.reportType = report["TYPE"];
          this.downloadResorces();
        }else{
          this._location.back();
        }
      }).catch((error) => {
        this.openSnackBar(this.translate.data['msg.error_generate_report'],"error");
        this.loading = false;
      });
    }else{
      this.downloadResorces();
    }
  }

  public downloadResorces(){
    if(this.external){
      this.handleExternalReport();
    }
    else if(this.reportId == null){
      this.downloadReportTypes();
    }else {
      this.downloadFormModel(this.reportId);
    }
  }

  public onDateChange(controlName){
    this.formGroup.get(controlName).setValue(moment(this.formGroup.get(controlName).value).format("YYYY-MM-DD"));
  }

  public handleExternalReport() {
    let body = this.externalParams;
    this.generateReport(body);
  }

  public concatStyles(styles:any[]):any{
    let result = new Object();
    for(let style of styles){
      result = Object.assign(result, style);
    }
    return result;
  }

  private setFormGroup(){
    let formModel = {};
    this.fields = {};

    for(let field of this.formModel.fields){
      if(field.name != null)
        this.fields[field.name] = field;
    }
    this.formModel.fields;
    for(let field of this.formModel.fields){
      let required = (field.required)?true:false;
      if(field.type == 'multiple_resource_selector'){
        this.fields[field.name].data.unshift({"value":"all","label":"nav.all"})
        this.fields[field.name]["value"]=field.data.map(d => d.value);
        formModel[field.name] = [this.fields[field.name]["value"],((required)?Validators.required:null)];
      }else if(field.type == 'date_range'){
        let defaultValue = field.default_value;
        if(defaultValue != null){
          defaultValue = {
            begin: moment(defaultValue).set("date",1),
            end: moment(defaultValue)
          }
        }
        formModel[field.name] = [defaultValue,((required)?Validators.required:null)];
      }else if(field.type == 'month'){
        let defaultValue = moment();
        formModel[field.name] = [defaultValue,((required)?Validators.required:null)];
      }else if(field.type == 'select'){
        let defaultValue = field.default_value;
        if(defaultValue == null && field.required) defaultValue = field.data[0].value;
        formModel[field.name] = [defaultValue,((required)?Validators.required:null)];
      }else{
        formModel[field.name] = [field.default_value,((required)?Validators.required:null)];
      }
    }
    this.formGroup = this.formBuilder.group(formModel);
  }

  public onMultipleChange(event, field){
    if(this.fields[field.name] != null && this.fields[field.name].type == "multiple_resource_selector"){
      let currentValues = event.value;
      let newValues = currentValues;
      let lastValues = this.fields[field.name]["value"];

      if(currentValues != lastValues){
        let allValues = field.data.map(d => d.value);
        allValues.splice(allValues.indexOf('all'),1);

        if(!lastValues.includes('all')){
          if(currentValues.includes('all')){
            newValues = ['all',...allValues];
          }else{
            if(!allValues.some(value => !currentValues.includes(value))){
              newValues = currentValues;
              newValues.unshift('all');
            }
          }
        }else{
          if(allValues.some(value => !currentValues.includes(value))){
            let newValues = currentValues;
            let index = newValues.indexOf('all');
            if(index >= 0)
              newValues.splice(index,1);
          }else if(!currentValues.includes('all')){
            newValues = [];
          }
        }
        this.formGroup.get(field.name).setValue(newValues);
        this.fields[field.name]["value"] = newValues;
      }
    }
  }

  private downloadReportTypes(){
    this.reportService.getResources().then((reportTypes) => {
      this.reportTypes = reportTypes;
    });
  }

  public downloadFormModel(id){
    this.loading = true;
    this.disableForm(true);
    this.reportService.getResource(id).then((formModel) => {
      this.formModel = formModel;
      this.setFormGroup();
    }).finally(()=>{
      this.loading = false;
      this.disableForm(false);
    });
  }

  public submit(){
    if(this.reportId != null){
      let body = this.formGroup.value;
      body['id'] = this.reportId;
      for(let field of this.formModel.fields){
        if(field.type == "multiple_resource_selector"){
          let index = body[field.name].indexOf('all');
          if(index >= 0)
            body[field.name].splice(index,1);
        }else if(field.type == "date_range"){
          body[field.name]["begin"] = moment(body[field.name]["begin"]).format("YYYY-MM-DD HH:mm:ss");
          body[field.name]["end"] = moment(body[field.name]["end"]).format("YYYY-MM-DD HH:mm:ss");
        }else if(field.type == "month"){
          body[field.name] = moment(body[field.name]).format("YYYY-MM").toString();
        }else if(field.type == "check"){
          body[field.name] = (body[field.name])?1:0;
        }
      }
      this.generateReport(body);
    }
  }

  private disableForm(disabled){
    if(this.formModel != null){
      for(let field of this.formModel.fields){
        if(disabled){
          this.formGroup.get(field.name).disable();
        }else{
          this.formGroup.get(field.name).enable();
        }
      }
    }
  }

  private generateReport(body){

    if(this.reportType == "jsreport"){
      this.loading = true;
      this.reportService.getAutoReportData(this.reportId, body).then((response) => {
          let reader = new FileReader();
          reader.readAsDataURL(new Blob([response.body as Blob], {type: 'application/pdf'}));
          reader.onloadend = () => {
              let base64data = reader.result;
              this.pdfViewer.nativeElement.setAttribute('data', base64data.toString());
          }
      }).catch((error) => {
          console.log('Error', error)
      }).finally(() => {
          this.loading = false;
      });
    }else{
      this.loading = true;
      this.disableForm(true);
      this.reportService.getReportData(body).then((report) => {
        if(report != null){
          this.tables = report["tables"];
          this.group_tables = report["group_tables"];
          this.report = report["report"];

          if(this.tables != null && this.tables.length > 0){
            this.translateTable(this.tables[0]);
          }

          if(this.group_tables != null && this.group_tables.length > 0){
            for(let table of this.group_tables){
              this.translateTable(table.table);
            }
          }

          let style = document.getElementById("stylePrint");
          if(style == null){
            style = document.createElement("style");
            document.head.appendChild(style);
            style.id = "stylePrint";
          }

          if(this.report != null && this.report.landscape != null && this.report.landscape == 1){
            style.innerHTML = '@page {size: landscape}';
          }else{
            style.innerHTML = '@page {size: portrait}';
          }
        }
      }).catch((error) => {
        console.log(error);
      }).finally(()=>{
        this.loading = false;
        this.disableForm(false);
      });
    }
  }

  translateTable(table){
    if(table != null && Object.keys(table).length > 0){
      for(let row of table.tbody.rows){
        for(let key of Object.keys(row)){
          let value = row[key]
          if(value != null){
            value = value.toString();
            let keylangs = value.match(/(\{\{\w*\.\w*\}\})/g);
            if(keylangs != null && Array.isArray(keylangs) && keylangs.length){
              keylangs.forEach(keylang => {
                value = value.replace(keylang, this.translate.data[keylang.replace("{{","").replace("}}","")]);
              });
            }
            row[key] = value;
          }
        }
      }
    }
  }

  public exportReport(){
    this.exporting = true;
    let body = this.formGroup.value;
    body['id'] = this.reportId;
    for(let field of this.formModel.fields){
      if(field.type == "month"){
        body[field.name] = moment(body[field.name]).format("YYYY-MM").toString();
      }else if(field.type == "check"){
        body[field.name] = (body[field.name])?1:0;
      }
    }
    this.reportService.getExportData(body).then((report:{title:string,table:{tbody:{rows:any[]},thead:{cols_header:any[]}}}) => {

      this.translateTable(report.table);
      this.dataexport.data = report.table.tbody.rows;
      this.dataexportfields = report.table.thead.cols_header.map(headers => headers.field);
      setTimeout(() => {
        document.getElementById("btexport").click();
        this.exporting = false;
      },1000);
    }).catch((error) => {
      console.log(error);
      this.exporting = false;
    }).finally(()=>{
      this.loading = false;
      this.disableForm(false);
    });
  }

  public jsonToStyleString(json){
    let style = "";
    if(json != undefined){
      for(let key of Object.keys(json)){
        style += `${key}:${json[key]};`;
      }
    }
    return style;
  }

  public translateContent(text){
    let items = text.match(/(\{\{(.*?)\}\})/g);
    if(items != null && Array.isArray(items) && items.length){
      for(let item of items){
        if(item.includes('|')){
          let value = item.split('|')[0].replace("{{","");
          let pipe = item.split('|')[1].replace("}}","");
          let result = value;
          if(pipe == "translate"){
            result = this.translate.data[value];
          }else if(pipe.includes("date")){
            if(pipe.includes("date:")){
              let format = pipe.replace("date:","");
              result = this.datePipe.transform(value,format,null,this.configurationService.getConfigLocale());
            }
          }else if(pipe.includes("number")){
            if(pipe.includes("number:")){
              let format = pipe.replace("number:","");
              result = this.decimalPipe.transform(value,format);
            }
          }else if(pipe.includes("time")){
            if(pipe.includes("time:")){
              let format = pipe.replace("time:","");
              result = this.secToDateTime.transform(value,format);
            }
          }
          text = text.replace(item, result);
        }else{
          try{
            text = text.replace(item, this.translate.data[item.replace("{{","").replace("}}","")]);
          }catch(error){
            console.log(error);
          }
        }
      }
    }
    return text;
  }

  public construct_table_groups(group_tables){
    let res = "";
    if(group_tables != null){
      res += `<div>`;
      let renderTable = (data) => {
        let table = "";
        if(data != null){
          table += `<div>`;
          if(data.header !=null && data.header.title != null && data.header.title.trim() != ''){
            table += `<div class="header w-100 pb-2">`;
            table += `<h5 class="mb-0" style="${(data.header)?this.jsonToStyleString(data.header.style):""}">{{${data.header.title}}}</h5>`;
            table += `</div>`;
          }
          table += `<table class="w-100 mb-4">`;
          if(data.thead && data.thead.cols){
            table += `<thead>`;
            table += `<tr style="${(data.thead && data.thead.style)?this.jsonToStyleString(data.thead.style):""}" class="border-bottom">`;
            let cols = (data.thead.cols_header.length > 0)?data.thead.cols_header:data.thead.cols;
            for(let column of cols){
              if(!column.style.hidden){
                table += `<td style="${(column)?this.jsonToStyleString(column.style):""}">{{${column.label}}}</td>`;
              }
            }
            table += `</tr>`;
            table += `</thead>`;
          }
          if(data.tbody){
            table += `<tbody style="${(data.tbody)?this.jsonToStyleString(data.tbody.style):null}">`;
            for(let row of data.tbody.rows){
              table += `<tr class="border-bottom">`;
              for(let column of data.thead.cols){
                if(!column.style.hidden){
                  table += `<td style="${this.jsonToStyleString(column.style)}">${(row[column.field]!=null)?this.format(row[column.field], column.type, column.format):''}</td>`;
                }
              }
              table+=`</tr>`;
            }
            table += `</tbody>`;
            table += `<tfoot style="${(data.tfoot)?this.jsonToStyleString(data.tfoot.style):""}">`;
              if(data.tfoot && data.tfoot.cols){
                table += `<tr>`;
                let cols = (data.thead.cols_header.length > 0)?data.thead.cols_header:data.thead.cols;
                for(let column of cols){
                  if(!column.style.hidden){
                    table += `<td style="${(column.style)?this.jsonToStyleString(column.style):""}">${(data.tfoot.cols[column.field] != null)? this.format(data.tfoot.cols[column.field], column.type, column.format):""}</td>`;
                  }
                }
                table+=`</tr>`;
              }
            table += `</tfoot>`;
          }
          table += `</table>`;
          table += `</div>`;
        }
        return table;
      }

      let recursive = (group_tables, level) => {
        let html = "";
        for(let group of group_tables){
          if(group["sub"] != null && group["sub"].length){
            html += `<div style="padding-left: 16px;padding-bottom: 18px;padding-top: 18px;border-bottom: 1px solid #eee;">`;
            html += group["title"];
            html += recursive(group["sub"], level+1);
            if(group["group_summarize"]){
              html += `<table class="w-100 mb-4">`;
              html += `<tbody style="${(group["group_summarize"].tbody)?this.jsonToStyleString(group["group_summarize"].tbody.style):null}">`;
              for(let row of group["group_summarize"].tbody.rows){
                html += `<tr class="border-bottom">`;
                let cols = (group["group_summarize"].thead.cols_header.length > 0)?group["group_summarize"].thead.cols_header:group["group_summarize"].thead.cols;
                for(let column of cols){
                  if(!column.style.hidden){
                    html += `<td style="${this.jsonToStyleString(column.style)}">${(row[column.field]!=null)?this.format(row[column.field], column.type, column.format):''}</td>`;
                  }
                }
                html+=`</tr>`;
              }
              html += `</tbody>`;
              html += `</table>`;
            }
            html += "</div>";
          }
          if(group["table"] != null){
            html += `<div style="clear:both"></div>`;
            html += `<div style="padding-left:16px;margin-bottom: 30px;">`;
            html += '<h3 style="font-size: 13pt;font-weight: 600;margin-bottom: 4px;white-space: nowrap;min-width:600px;text-transform: uppercase;">'+group["title"]+'</h3>';
            html += renderTable(group["table"]);
            html += "</div>";
          }
        }
        return html;
      }
      res += recursive(group_tables, 0);

      res += "</div>";
    }
    return res;
  }

  public format(value, type, format){
    let locale = this.configurationService.getConfigLocale();
    let result = value;
    if(value != null){
      if(String(value).trim() != ''){
        try{
          switch(type){
            case 'number':
              result = formatNumber(Number(value), this.translate.lang, format);
              break;
            case 'text':
              result = value.toString();
              break;
            case 'datetime':
              if(this[format] != null){
                result = this[format].transform(value,locale);
              }
              break;
            case 'shortdate':
              if(this[format] != null){
                result = formatDate(value,"shortDate",locale);
              }
              break;
            case 'time':
              result = this.secToDateTime.transform(value, format);
          }
        }catch(error){
          console.log(error)
          result = value;
        }
      }
    }
    return result;
  }

  chosenMonthHandler(normalized: Moment, control:AbstractControl, datepicker) {
    /*let ctrlValue = control.value;
    ctrlValue.year(normalized.year());
    ctrlValue.month(normalized.month());*/
    control.setValue(normalized);
    //control.setValue(ctrlValue.format("YYYY-MM"));
    datepicker.close();
  }

  public toggleOptions(){
    this.showOptions = !this.showOptions;
  }

  public downloadPDFV2() {
    this.printing = true;
    let reports = window.document.getElementById("reports").innerHTML;
    //this.iframe.nativeElement.contentDocument.write(reports);
    this.iframe.nativeElement.contentWindow.document.body.innerHTML = reports
    this.iframe.nativeElement.contentWindow.document.head.innerHTML = window.document.head.innerHTML;
    this.iframe.nativeElement.contentWindow.document.body.style.padding = "30px";
    setTimeout(() => {
      this.iframe.nativeElement.contentWindow.focus();
      this.iframe.nativeElement.contentWindow.print();
      this.printing = false;
    },3000)
    window.focus();
  }

  public openSnackBar(message: string, type:string) {
    let config: MatSnackBarConfig = {
      panelClass: 'snack_' + type,
      duration: 6000,
      horizontalPosition: 'right',
      verticalPosition: 'bottom'
    };
    this._snackBar.open(message, "Ok", config);
  }

}
